import { Heart, Coffee, ExternalLink } from "lucide-react";
import { getAdminToken } from "@/lib/api";
import DecodeRequestForm from "@/components/donate/DecodeRequestForm";
import RequestsInbox from "@/components/donate/RequestsInbox";

const PAYPAL_LINK = "https://www.paypal.com/qrcodes/p2pqrc/X5P3DXFPMGNP2";

export default function Donate() {
  return (
    <section className="max-w-3xl mx-auto space-y-10">
      <header className="space-y-3 rise">
        <div className="font-mono text-[10px] uppercase tracking-[0.3em] muted">// Donate</div>
        <h1 className="font-display text-4xl sm:text-5xl tracking-tight leading-[1.05]">
          Fuel the <span className="gold italic">decoding</span>.
        </h1>
        <p className="muted text-sm max-w-2xl leading-relaxed">
          Gem Key is free and always will be. If it's helped you decode something, a small
          tip keeps the dictionary growing and covers the running costs.
        </p>
      </header>

      <div
        className="rise rise-1 panel p-6 md:p-8 border-[rgba(212,175,55,0.4)]"
        data-testid="donate-panel"
      >
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-sm border border-[rgba(212,175,55,0.4)] flex items-center justify-center shrink-0">
            <Heart className="gold" size={18} fill="currentColor" />
          </div>
          <div>
            <div className="font-mono text-[10px] uppercase tracking-[0.22em] gold">
              // PayPal
            </div>
            <div className="font-display text-lg text-white mt-0.5">
              Send any amount, any currency
            </div>
          </div>
        </div>

        <p className="muted text-sm leading-relaxed mb-5">
          Tap the button — PayPal opens with the amount blank. Pick whatever you like.
          Every bit is genuinely appreciated. ❤️
        </p>

        <a
          href={PAYPAL_LINK}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="donate-paypal-btn"
          className="btn-primary w-full sm:w-auto px-6 py-4 text-sm flex items-center justify-center gap-3"
        >
          <Coffee size={16} />
          <span>Donate via PayPal</span>
          <ExternalLink size={14} />
        </a>

        <div className="mt-6 pt-5 border-t border-white/10 flex items-start gap-3">
          <img
            src="https://customer-assets.emergentagent.com/job_numerology-cipher/artifacts/nz4j3yvt_pp_p2p_my_qrcode_1783131950227.jpg"
            alt="Gem Key PayPal QR code — scan to donate"
            className="w-32 h-32 shrink-0 rounded-sm bg-white p-1"
            data-testid="donate-qr"
          />
          <div className="min-w-0">
            <div className="font-mono text-[10px] uppercase tracking-[0.18em] muted">
              // Or scan
            </div>
            <p className="muted text-sm mt-1 leading-relaxed">
              Scan the QR with your phone's camera or PayPal app. Works from anywhere in
              the world — PayPal converts currency for you.
            </p>
          </div>
        </div>
      </div>

      <DecodeRequestForm />

      {getAdminToken() && <RequestsInbox />}

      <div className="rise rise-2 muted text-xs font-mono tracking-wider leading-relaxed text-center">
        <span aria-hidden="true">🙏</span> Thank you for keeping <span className="gold">Gem</span> Key alive.
      </div>
    </section>
  );
}
